export default "__VITE_ASSET__DanBi4UQ__"